import {
    Card,
    CardContent,
    Container,
    Divider,
    Grid,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    Button,
} from '@mui/material';
import AccordionItem from '../../FicheEA/AccordionItem';
import EvaluationCompetenceBM from './EvaluationCompetenceBM';
import { Trans, useTranslation } from 'react-i18next';
import EmployeeIdentity from './EmployeeIdentity';
import SkillsAssessment from './SkillsAssessment';
import ManagerComments from './ManagerComments';
import OtherActionsNextYear from './OtherActionsNextYear';
import OtherWishes from './OtherWishes';
import ProfessionalProjection from './ProfessionalProjection';
import GlobalSkillsSummary from './GlobalSkillsSummary';
import AchievedAndExpectedResults from './AchievedAndExpectedResults';
import EvaluationCriteria from './EvaluationCriteria';
import { useContext, useEffect, useState } from 'react';
import { businessManagerService } from 'src/services';
import { BusinessManager, GlobalSkillsSummaryModel } from 'src/models/businessManager/businessManager.model';
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ActionContext } from 'src/contexts/ActionContext';
import { useParams } from 'react-router-dom';
import { User } from 'src/models/user/user.model';
import { CURRENT_USER } from 'src/constants';
import SuspenseLoader from 'src/components/SuspenseLoader';
import ASMAlert from 'src/components/Alert';

function PreparationEEPBM(props) {
    const {
        actionToggle,
        hasManagerPermission,
        hasManagerPermissionResendBoond
    } = useContext(ActionContext);
    const params = useParams();
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const { i18n } = useTranslation();
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const { t } = useTranslation();
    const { eepBMData, setIdBusinessManagerContext } = useContext(BusinessManagerContext);
    const [BMData, setBMData] = useState<BusinessManager[]>([]);
    const [idBusinessManager, setIdBusinessManager] = useState<number>(0);
    const [BMName, setBMName] = useState('');
    const isVisu = !actionToggle;
    const [globalSkillsSummary, setGlobalSkillsSummary] = useState<GlobalSkillsSummaryModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [openGlobalSkillsSummary, setOpenGlobalSkillsSummary] = useState(true);
    const [forRefresh, setForRefresh] = useState(false);
    const onChangeGlobalSkillsSummary = () => {
        setLoading(true)
        setOpenGlobalSkillsSummary(true)
        setLoading(false)
    }
    useEffect(() => {
        if (forRefresh) {
            setOpenGlobalSkillsSummary(true)
        }
        if (idBusinessManager != 0 && openGlobalSkillsSummary) {
            setLoading(true)
            let request = {
                idUser: userData.id,
                year: params.year,
                idLang: i18n.language === 'fr' ? 1 : 2,
                idBusinessManager: idBusinessManager
            };
            if (params.id != undefined) {
                request = {
                    idUser: parseInt(params.id),
                    year: params.year,
                    idLang: i18n.language === 'fr' ? 1 : 2,
                    idBusinessManager: idBusinessManager
                };
            }
            businessManagerService.getGlobalSkillsSummary(request).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setGlobalSkillsSummary(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openGlobalSkillsSummary]);

    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            let request = {
                idUser: userData.id,
                year: params.year,
                idLang: i18n.language === 'fr' ? 1 : 2,
                idBusinessManager: idBusinessManager
            };
            if (params.id != undefined) {
                request = {
                    idUser: parseInt(params.id),
                    year: params.year,
                    idLang: i18n.language === 'fr' ? 1 : 2,
                    idBusinessManager: idBusinessManager
                };
            }
            businessManagerService.getGlobalSkillsSummary(request).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setGlobalSkillsSummary(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [idBusinessManager]);

    const refreshData = () => {
        setForRefresh(true)
        setOpenGlobalSkillsSummary(false)
    }
    useEffect(() => {
        businessManagerService.getBusinessManager().then(response => {
            if (response.data.success) {
                setBMData(response.data.data)
            }
        }).catch(err => {

        });
    }, []);

    useEffect(() => {
        if (props.idBusinessManager != undefined && props.idBusinessManager != null) {
            setIdBusinessManager(props.idBusinessManager)
        }
    }, [props.idBusinessManager]);

    useEffect(() => {
        if (props.businessManagerName != undefined && props.businessManagerName != null && props.businessManagerName != "") {
            setBMName(props.businessManagerName)
        }
    }, [props.businessManagerName]);

    const handleChange = (event) => {
        setIdBusinessManager(event.target.value);
        setIdBusinessManagerContext(event.target.value);
        let BMTmp = BMData.find(x => x.id === event.target.value);
        if (BMTmp != null) {
            setBMName(BMTmp.name);
        } else {
            setBMName("");
        }
        eepBMData.idBusinessManager = event.target.value
    };

    const soumettreButton = () => {
        if (props.idStatus < 2) {
            return (
                <>
                    <Button variant="contained"
                        style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid', marginRight: 20 }}
                        startIcon={<PlayArrowIcon style={{ fontSize: 25 }} />}
                        onClick={props.submitEEPBM}
                    >
                        <Trans>button.submit</Trans>
                    </Button>
                </>
            );
        } else {
            return (<></>);
        }
    };

    const signerButton = () => {
        return (
            <>
                {
                    (props.idStatus === 2 && hasManagerPermission) &&
                    <>
                        <Button variant="contained"
                            style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid' }}
                            startIcon={
                                <img
                                    src={'/static/images/tools/Groupe 17.svg'}
                                    style={{ width: 22, height: 20 }}
                                />
                            }
                            onClick={props.validateSendBoondSigned}
                        >
                            <Trans>button.validateSendBoondSigned</Trans>
                        </Button>
                        <Button variant="contained"
                            style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid', float: 'right' }}
                            startIcon={<img src={'/static/images/tools/Groupe 17.svg'} style={{ width: 22, height: 20 }} />}
                            onClick={props.resendDraft}
                        >
                            <Trans>button.resendDraft</Trans>
                        </Button>
                    </>
                }
                {
                    (props.idStatus === 3 && hasManagerPermissionResendBoond) &&
                    <>
                        <Button variant="contained"
                            style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid' }}
                            startIcon={<img src={'/static/images/tools/Groupe 17.svg'} style={{ width: 22, height: 20 }} />}
                            onClick={props.resendBoond}
                        >
                            <Trans>button.resendBoond</Trans>
                        </Button>
                    </>
                }
            </>
        );
    };

    return (
        <>
            <Container maxWidth="lg">
                {loading && (
                    <>
                        <SuspenseLoader />
                    </>
                )}
                <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
                <Grid container
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={3}
                >
                    <Grid item xs={12}>
                        <Card sx={{ position: 'sticky', top: 0 }}>
                            <Grid
                                container
                                direction="row"
                                alignItems="stretch"
                                style={{ marginBottom: -20, marginTop: 15, paddingLeft: 32, paddingRight: 32 }}
                            >
                                <Grid item xs={4}>
                                    <FormControl fullWidth disabled={isVisu}>
                                        <InputLabel id="profil-label"><Trans>eepBm.profil</Trans></InputLabel>
                                        <Select
                                            label={t('eepBm.profil')}
                                            labelId="profil-label"
                                            id="profilForm"
                                            onChange={handleChange}
                                            name='idBusinessManager'
                                            required
                                            fullWidth
                                            value={idBusinessManager}
                                        >
                                            <MenuItem value={0} disabled>
                                                <em><Trans>variant.select</Trans></em>
                                            </MenuItem>
                                            {BMData.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8}></Grid>
                            </Grid>
                            <CardContent>
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="stretch"
                                    sx={{ padding: 2 }}
                                >
                                    <Grid item xs={12}>
                                        <AccordionItem
                                            open={true}
                                            title={t('eepBm.tabs.tab1')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<EmployeeIdentity data={props.employeeIdentityData} />}
                                        />
                                        <Grid item xs={12}><h3 style={{ textTransform: 'uppercase' }}><Trans>eepBm.sections.section1</Trans></h3></Grid>
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab2')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={
                                                <EvaluationCompetenceBM idBusinessManager={idBusinessManager} />
                                            }
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab3')}
                                            icon='eval_competence_icon.svg'
                                            open={openGlobalSkillsSummary}
                                            alwaysOpen={true}
                                            onChange={onChangeGlobalSkillsSummary}
                                            accordionContent={
                                                openGlobalSkillsSummary ? <GlobalSkillsSummary
                                                    isVisu={isVisu}
                                                    refreshData={refreshData}
                                                    idBusinessManager={idBusinessManager}
                                                    data={globalSkillsSummary}
                                                /> : <></>
                                            }
                                        />
                                        {/* <AccordionItem
                                            title={t('eepBm.tabs.tab3')}
                                            icon='eval_competence_icon.svg'
                                            open={true}
                                            accordionContent={
                                                <GlobalSkillsSummary
                                                    isVisu={isVisu}
                                                    refreshData={refreshData}
                                                    idBusinessManager={idBusinessManager}
                                                    data={globalSkillsSummary}
                                                />
                                            }
                                        /> */}
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab4')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<AchievedAndExpectedResults
                                                data={props.achievedAndExpectedResults}
                                                isVisu={isVisu} />}
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab5') + BMName}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<EvaluationCriteria idBusinessManager={idBusinessManager} />}
                                        />
                                        <Grid item xs={12}><h3 style={{ textTransform: 'uppercase' }}><Trans>eepBm.sections.section2</Trans></h3></Grid>
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab6')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<SkillsAssessment idEEPBM={props.idEEPBM} data={props.skillsAssessment} />}
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab7')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<ProfessionalProjection data={props.professionalProjection} />}
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab8')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<OtherWishes data={props.degreeObtainPeriodtherWishes} />}
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab9')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<OtherActionsNextYear idEEPBM={props.idEEPBM} />}
                                        />
                                        <AccordionItem
                                            title={t('eepBm.tabs.tab10')}
                                            icon='eval_competence_icon.svg'
                                            accordionContent={<ManagerComments data={props.managerComments} />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        {soumettreButton()}
                                    </Grid>
                                    <Grid item xs={12} >
                                        {signerButton()}
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <Divider />
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default PreparationEEPBM;